import { FormInputBase } from './form-input-base';

export class DateInput extends FormInputBase<string> {
  override controlType = 'date';
}
